import { productEntitlementsSchema } from '@inkitt/contracts-common';
import { z } from 'zod';
import { booleanQueryParam, c } from '../../contract';
import { productsQuerySchema } from '../../utils/productsQuery';

const userEntitlementsQuerySchema = z.object({
  callSource: z.string().optional(),
  stripeCustomerId: z.string().optional(),
  bypassCache: booleanQueryParam.optional(),
  includeDebugData: booleanQueryParam.optional(),
  products: productsQuerySchema,
});

export const userRouter = c.router(
  {
    getGeolocation: {
      summary: 'Get geolocation info for the user',
      method: 'GET',
      path: '/geolocation',
      responses: {
        200: z.object({
          geo: z.object({
            ip: z.string(),
            city: z.string().optional(),
            countryCode: z.string().optional(),
            regionCode: z.string().optional(),
            postalCode: z.string().optional(),
          }),
        }),
      },
    },
    entitlements: {
      summary: 'Get user entitlements',
      method: 'GET',
      path: '/entitlements',
      query: userEntitlementsQuerySchema,
      responses: {
        200: productEntitlementsSchema,
      },
    },
    redeemDeeplinkAuthToken: {
      summary:
        'Redeem an opaque, single-use deeplink auth token (minted by CandyJar) for a Firebase custom token, to sign the user into Galatea via a cross-app handoff deep link',
      method: 'POST',
      path: '/deeplink-auth-token/redeem',
      body: z.object({ token: z.string().min(1) }),
      responses: {
        200: z.object({ customToken: z.string().min(1) }),
        404: z.literal('Token Not Found'),
      },
    },
  },
  { pathPrefix: '/user' },
);
